/* MINIMOSAIC — predictive search (mm-predictive-search)
   Live product suggestions from Shopify's /search/suggest.json as you type.
   Sold-out products are hidden; products with variants show their full
   price range (lowest – highest). */
(function () {
  'use strict';
  if (customElements.get('mm-predictive-search')) return;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  class MMPredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('.mm-psearch__input');
      this.results = this.querySelector('.mm-psearch__results');
      this.root = this.getAttribute('data-root') || '/';
      this.searchUrl = this.getAttribute('data-search-url') || (this.root + 'search');
      this.symbol = this.getAttribute('data-currency-symbol') || '$';
      this.seeAll = this.getAttribute('data-see-all') || 'SEE ALL RESULTS';
      this.emptyText = this.getAttribute('data-empty') || 'No results';
      this.timer = null;
      this.controller = null;
      this.active = -1;
      if (!this.input || !this.results) return;

      this.input.addEventListener('input', () => this.onInput());
      this.input.addEventListener('focus', () => { if (this.results.children.length) this.show(); });
      this.input.addEventListener('keydown', (e) => this.onKey(e));
      document.addEventListener('click', (e) => { if (!this.contains(e.target)) this.hide(); });
    }

    onInput() {
      clearTimeout(this.timer);
      var q = this.input.value.trim();
      if (q.length < 2) { this.hide(); this.results.innerHTML = ''; return; }
      this.timer = setTimeout(() => this.fetch(q), 180);
    }

    fetch(q) {
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      var url = this.root + 'search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=6' +
        '&resources[options][unavailable_products]=hide' +
        '&resources[options][fields]=title,product_type,variants.title,variants.sku,tag';
      fetch(url, { signal: this.controller.signal, headers: { Accept: 'application/json' } })
        .then((r) => r.json())
        .then((data) => {
          var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
          products = products.filter((p) => p.available !== false);
          this.render(products, q);
        })
        .catch((err) => { if (err.name !== 'AbortError') console.error('[mm] predictive search failed', err); });
    }

    render(products, q) {
      var html = '';
      if (!products.length) {
        html = '<div class="mm-psearch__empty">' + esc(this.emptyText) + '</div>';
      } else {
        html = products.map((p, i) => {
          var img = p.image ? '<img class="mm-psearch__img" src="' + esc(p.image) + '" alt="" loading="lazy">' : '<div class="mm-psearch__img"></div>';
          var price = '';
          if (p.price_min != null && p.price_max != null && String(p.price_min) !== String(p.price_max)) {
            price = this.symbol + esc(p.price_min) + ' – ' + this.symbol + esc(p.price_max);
          } else if (p.price != null) {
            price = this.symbol + esc(p.price);
          }
          return '<a class="mm-psearch__item" role="option" id="' + this.results.id + '-' + i + '" href="' + esc(p.url) + '">' +
            img + '<div class="mm-psearch__body"><div class="mm-psearch__title">' + esc(p.title) + '</div>' +
            '<div class="mm-psearch__price">' + price + '</div></div></a>';
        }).join('');
        html += '<a class="mm-psearch__all" href="' + esc(this.searchUrl) + '?q=' + encodeURIComponent(q) + '&type=product&options[prefix]=last">' + esc(this.seeAll) + ' ▶</a>';
      }
      this.results.innerHTML = html;
      this.active = -1;
      this.show();
    }

    onKey(e) {
      var items = this.results.querySelectorAll('[role="option"]');
      if (e.key === 'Escape') { this.hide(); return; }
      if (!items.length || this.results.hidden) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        this.active = e.key === 'ArrowDown' ? Math.min(items.length - 1, this.active + 1) : Math.max(0, this.active - 1);
        items.forEach((el, i) => el.setAttribute('aria-selected', i === this.active ? 'true' : 'false'));
        this.input.setAttribute('aria-activedescendant', items[this.active].id);
        items[this.active].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter' && this.active >= 0) {
        e.preventDefault();
        window.location.href = items[this.active].getAttribute('href');
      }
    }

    show() { this.results.hidden = false; this.input.setAttribute('aria-expanded', 'true'); }
    hide() { this.results.hidden = true; this.input.setAttribute('aria-expanded', 'false'); this.input.removeAttribute('aria-activedescendant'); }
  }
  customElements.define('mm-predictive-search', MMPredictiveSearch);
})();